import { createContext, Ref, useContext } from "react";

export const DossierScrollContext = createContext<{
    isScrolled: { left: boolean; top: boolean };
    ref: Ref<HTMLDivElement>;
} | null>(null);

export function useDossierScrollDetails() {
    const ctx = useContext(DossierScrollContext);
    if (!ctx) throw new Error("useDossierScrollDetails must be used within DossierDetailsPanel");
    return ctx;
}
